import ClassroomAPI from '@skooldio/classroom-frontend-api';

import getConfig from '../Util/Config';

const getApolloClient = (authorizationFunction, deviceInfo = {}) => {
  const { graphApi: graphqlPath, examApi: examRestPath, studentApi: studentRestPath } = getConfig();
  const additionalHeader = {};

  if (deviceInfo.uuid) {
    additionalHeader['x-forwarded-device-identity'] = deviceInfo.uuid;
  }

  return ClassroomAPI.createClient({
    authorizationFunction,
    graphqlPath,
    examRestPath,
    studentRestPath,
    additionalHeader,
  });
};

export default getApolloClient;
